export default __webpack_public_path__ + "static/media/leaBlue.b74d4141.svg";